import React from 'react'

import PropTypes from 'prop-types'

import IconBase, { Path, Circle } from '../IconBase/IconBase'

function CircleX({
  color = 'icon.primary',
  strokeColor = 'icon.white',
  strokeWidth = 1.5,
  borderColor = 'icon.white',
  ...props
}) {
  return (
    <IconBase viewBox='0 0 22 21' {...props}>
      <Circle
        cx='10.875'
        cy='10.5'
        r='10.5'
        fill={color}
        stroke={borderColor ?? strokeColor}
      />
      <Path
        d='M14.375 7L7.375 14'
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <Path
        d='M14.375 14L7.375 7'
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </IconBase>
  )
}

CircleX.propTypes = {
  color: PropTypes.string,
  strokeColor: PropTypes.string,
  borderColor: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default CircleX
